import { render, staticRenderFns } from "./ManageMerchantDetails.vue?vue&type=template&id=079ec94a&scoped=true"
import script from "./ManageMerchantDetails.vue?vue&type=script&lang=js"
export * from "./ManageMerchantDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079ec94a",
  null
  
)

export default component.exports